import React, { useState } from "react";
import { Dropdown, Button, Icon } from "xsolla-uikit";
export const Reset = ({ title = "Reset", labels = [], icon = 'redo'}) => {
  const [act, setAct] = useState(true);
  return (<Dropdown align="right"
    // autosize={true}
    size="md"
    // separated={true}
    iconAlign='left' options={labels.map((one) => ({
      label: <div onClick={() => { setAct(true); }} size="sm" appearance="flatten">
        <span style={{ fontSize: 13 }}>
          {one['title']}
        </span>
      </div>,
      description: one['description'],
    }))}>



    <Button appearance="flatten" style={{color: `rgb(116, 126, 138)`}}>
      <Icon name={icon} size={18} />&nbsp;{title}
    </Button>



  </Dropdown>);
};
